import { message as $message } from 'antd'
import streamSaver from 'streamsaver'
import last from 'lodash/last'
import dayjs from 'dayjs'
import download from 'gyl-common/tools/download'
import { captureException } from '@/utils/track'
import { imageToOss } from '@/services/goods'

export const createExcelName = name => `${name}-${dayjs().format('YYYYMMDDHHmmss')}.xlsx`

export const loadBlob = ({ file, fileName }) => {
    const linkEle = document.createElement('a')

    const objUrl = window.URL.createObjectURL(file)

    console.info('loadBlob:', file)

    linkEle.href = objUrl
    linkEle.download = fileName
    linkEle.click()

    window.URL.revokeObjectURL(objUrl)

    return linkEle
}
// url 下载（downloadFile不支持跨域的url）
// href属性的地址必须是和你前端js非跨域的地址，如果引用的是第三方的网站或者说是前后端分离的项目，调用后台的接口，这时download就会不起作用
export const loadLink = ({ filePath, fileName }) => {
    const linkEle = document.createElement('a')
    linkEle.href = filePath
    if (fileName) {
        linkEle.download = fileName
    }
    // 添加到 DOM 中并触发点击
    document.body.appendChild(linkEle)
    linkEle.click()

    // 移除链接以清理 DOM
    document.body.removeChild(linkEle)
}

// 下载文件
export const downloadFile = async ({ filePath, fileName, errorMap = {} }) => {
    const res = await fetch(filePath)

    if (res.status !== 200) {
        const errorMsg = errorMap[res.status] || errorMap.default
        if (errorMsg) {
            $message.error(errorMsg)
            return Promise.reject(errorMsg)
        }
    }

    try {
        const blob = await res.blob()

        loadBlob({ file: blob, fileName })

        return Promise.resolve()
    } catch (err) {
        console.error('catchError', err)
        captureException('下载转bolb出错', {
            anchor: '转bolb'
        })
    }
    return Promise.reject(new Error('下载失败'))
}

/*
 * 下载文件兼容性方式（后端可能给文件流也可能给文件地址）
 * fetch: function  获取数据方法
 * filename: string 需要带文件后缀
 * */
export const compatibleDownloadFile = async ({ fetch, fileName, filePath }) => {
    try {
        if (!fetch && filePath) {
            await downloadFile({ filePath, fileName })
            return
        }

        const res = await fetch()

        // 文件流
        if (res instanceof Blob) {
            loadBlob({ file: res, fileName })
            return Promise.resolve()
        }

        const { success, data, message } = res

        // 文件地址
        if (success) {
            await downloadFile({ filePath: data, fileName })
            return Promise.resolve()
        } else {
            $message.error(message)
        }
    } catch (e) {
        console.error('catchError', e)
        $message.error('操作失败')
    }
    return Promise.reject(new Error(`下载${fileName} 失败`))
}

/**
 * downloadFileByStream
 * 通过WriteStream流来下载相应的资源，优点是可以在浏览器中得到相应的进度
 * 可用来下载视频等资源
 * @param {*} url 资源路径
 * @param {*} filename 下载文件名称
 * @returns
 */
export const downloadFileByStream = async ({ url, fileName }) => {
    const defaultFileName = last(url?.split('/'))
    const res = await fetch(url)
    // 创建写入流 filename为下载的文件名
    const fileStream = streamSaver.createWriteStream(fileName || defaultFileName, {
        size: res.headers.get('content-length')
    })
    const readableStream = res.body
    if (window.WritableStream && readableStream.pipeTo) {
        return readableStream.pipeTo(fileStream).then(() => {})
    }
    window.writer = fileStream.getWriter()
    const reader = res.body.getReader()
    const pump = () =>
        reader.read().then(res => (res.done ? window.writer.close() : window.writer.write(res.value).then(pump)))
    pump()
}

/*
 * @description 流式下载多文件，单文件直接下载文件，多文件为压缩包
 * */
export const downloadFilesByStream = ({ files, packageName }) => {
    return download({
        files,
        packageName,
        fetch: url => {
            return fetch(url).catch(() => {
                return imageToOss({ imageList: [url] }).then(res => {
                    if (res.success && res.data) {
                        return fetch(res.data?.[0]?.ossImage)
                    } else {
                        $message.error(res.message)
                    }

                    return Promise.reject(new Error('图片地址转换失败'))
                })
            })
        }
    })
}

export const transImageToSursung = imgSrcList => {
    const isSursung = imgSrc => {
        const url = new URL(imgSrc)
        return url.origin.endsWith('images.sursung.com')
    }
    const transList = []
    imgSrcList.forEach((imgSrc, index) => {
        if (!isSursung(imgSrc)) {
            transList.push({ index, imgSrc })
        }
    })
    if (transList.length) {
        return new Promise((resolve, reject) => {
            imageToOss({
                imageList: transList.map(_ => _.imgSrc)
            })
                .then(({ success, data }) => {
                    if (success && data?.length) {
                        const result = imgSrcList.map(img => {
                            const transItem = data.find(_ => _.sourceImage === img)
                            if (transItem) {
                                return transItem.ossImage
                            }

                            return img
                        })
                        resolve(result)
                    } else {
                        $message.error('图片地址转化失败')
                        reject(Error('图片地址转化失败'))
                    }
                })
                .catch(reject)
        })
    } else {
        return Promise.resolve([...imgSrcList])
    }
}
